module.exports = __webpack_public_path__ + "media/images/shared/youtube_social_squircle_dark-0fb86ef4d9aaf6c2515eee70524167ec.png";